module.exports = __webpack_public_path__ + "img/skills-lightning-sor-1.50a578d8.png";